import { SoftManagerService } from '@vfit/consumer/providers';
import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { setTrackLink } from '@vfit/shared/data-access';
import { retrieveProductTechnology } from '@vfit/consumer/data-access';
import { useQueryClient } from 'react-query';
import { removeCurrency } from '@vfit/consumer/hooks';
import { CoverageErrorType } from '@vfit/shared/models';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';

const CoverageToolErrorTagging = ({
  coverageErrorType,
}: {
  coverageErrorType: CoverageErrorType;
}) => {
  const client = useQueryClient();
  const { product } = useCoverageToolModalProvider();

  const pageProduct = {
    product_name: product?.slug,
    product_price: product?.price && removeCurrency(product.price),
    product_id: `${product?.offerId}`,
    product_quantity: '1',
    product_category: ['fixed'],
  };

  const opts = {
    event_category: 'tools',
    page_subsection: 'coverage tool',
    page_section: 'fixed offers',
    page_type: 'coverage ko',
    journey_name: 'coverage tool',
    product_technology: retrieveProductTechnology(),
  };

  const { trackView } = useTracking({
    event: ['tool_end'],
    event_label: coverageErrorType !== CoverageErrorType.FWA ? 'no coverage' : 'fwa coverage',
    opts,
    pageProduct,
    cartProduct: { cart_product_name: product?.slug || '' },
    visitorTrackingOpts: SoftManagerService(client).getUser(),
  });
  setTrackLink(trackView);
  setTrackView(trackView);

  return null;
};
export default CoverageToolErrorTagging;
